import { apiBaseUrl } from "./config"

const baseUrl = `${apiBaseUrl}/roles`;

async function getRoles(type) {
  let url = `${baseUrl}`;
  if (type) {
    url += `?type=${type}`;
  }
  const r = await fetch(url);
  const data = await r.json();
  return data;
}

const levels = {
  nacional: 1,
  region: 2,
  diocesis: 3,
  comunidad: 4,
  equipo: 5
}

function getPageOrgLevel(params) {
  let level = levels.nacional;
  if (params.regionId) {
    level = levels.region;
  }
  else if (params.diocesisId) {
    level = levels.diocesis;
  }
  else if (params.comunidadId) {
    level = levels.comunidad;
  }
  else if (params.teamId) {
    level = levels.equipo;
  }
  return level;
}

export {
  getRoles,
  levels,
  getPageOrgLevel
};
